import { useState, useMemo, useEffect, useRef } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import PageWrapper from "../components/PageWrapper";
import { createPortal } from "react-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default function MutasiMasuk() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [searchScan, setSearchScan] = useState("");
  const [activeTab, setActiveTab] = useState("ALL");
  const [reasonQty, setReasonQty] = useState(1);
  const [openMenu, setOpenMenu] = useState(null);
const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
const [selectedMutasi, setSelectedMutasi] = useState([]);
const [rejectModalOpen, setRejectModalOpen] = useState(false);
const [rejectReason, setRejectReason] = useState("");
const [selectedKoli, setSelectedKoli] = useState("");
const [previewImage, setPreviewImage] = useState(null);
const [isKoliLocked, setIsKoliLocked] = useState(false);
const [zoom, setZoom] = useState(1);

const [scanReceiveModal, setScanReceiveModal] = useState(false);
const [scanReceiveInput, setScanReceiveInput] = useState("");
const scanReceiveRef = useRef(null);

const [skuModal, setSkuModal] = useState(false);
const [skuItem, setSkuItem] = useState(null);
const [skuInput, setSkuInput] = useState("");

const [uniqModal, setUniqModal] = useState(false);
const [scanItem, setScanItem] = useState(null);
const [uniqInput, setUniqInput] = useState("");


const [menuRef, setMenuRef] = useState(null);
  const [shippingModal, setShippingModal] = useState(false);
const [selectedRow, setSelectedRow] = useState(null);
const [toast, setToast] = useState(null);

const [detailModal, setDetailModal] = useState(false);
const [orderDetail, setOrderDetail] = useState([]);
const [loadingDetail, setLoadingDetail] = useState(false);
const [loadingScanModal, setLoadingScanModal] = useState(false);

const [selectedItems, setSelectedItems] = useState([]);
const [groupMode, setGroupMode] = useState("uniq"); // uniq | group
const [scanResult, setScanResult] = useState([]);

const [reasonModal, setReasonModal] = useState(false);
const [reasonText, setReasonText] = useState("");
const [reason, setReason] = useState("");
const [selectedReasonItem, setSelectedReasonItem] = useState(null);


const [scanSummary, setScanSummary] = useState({


  total: 0,
  scanned: 0,
  remaining: 0,
  status: "BELUM SESUAI",
});

const toggleSelectMutasi = (row) => {
  const exists = selectedMutasi.find(
    (x) => x.id_perintah_mutasi === row.id_perintah_mutasi
  );

  if (exists) {
    setSelectedMutasi(
      selectedMutasi.filter(
        (x) => x.id_perintah_mutasi !== row.id_perintah_mutasi
      )
    );
  } else {
    setSelectedMutasi([...selectedMutasi, row]);
  }
};

// bikin helper
const isBelumPosting =
  selectedRow?.status === "BELUM POSTING";
// GROUPING
const groupedData =
  groupMode === "group"
    ? Object.values(
        orderDetail.reduce((acc, item) => {
          const key = `${item.kode_extend}_${item.ukuran}`;

          if (!acc[key]) {
            acc[key] = {
              kode_extend: item.kode_extend,
              ukuran: item.ukuran,
              qty: 0,
              items: [],
            };
          }

          acc[key].qty += 1;
          acc[key].items.push(item);

          return acc;
        }, {})
      )
    : [];

// CHECK SINGLE
const toggleItem = (uniq_id) => {
  setSelectedItems((prev) =>
    prev.includes(uniq_id)
      ? prev.filter((x) => x !== uniq_id)
      : [...prev, uniq_id]
  );
};

// CHECK ALL
const toggleAll = () => {
  if (selectedItems.length === orderDetail.length) {
    setSelectedItems([]);
  } else {
    setSelectedItems(orderDetail.map((x) => x.uniq_id));
  }
};

const showToast = (message, type = "success") => {
  setToast({ message, type });

  setTimeout(() => {
    setToast(null);
  }, 3000);
};


const exportDetailToExcel = async () => {
    const data = await fetchExportDetail(
    selectedRow?.id_perintah_mutasi
  );  

  const rows = data.map((item, index) => ({
    No: index + 1,
    "ID Instruksi": item.id_perintah_mutasi,
    "Status": item.status || "-",
    "Unique ID": item.uniq_id,
    Barcode: item.barcode,
    SKU: item.kode_extend,
    Ukuran: item.ukuran,
    Qty: parseInt(item.total_qty, 10) || 0,
"Qty Proses": parseInt(item.qty_received, 10) || 0,
    HJP: item.hjp,
    Koli: item.nomor_koli || "-",
    Status: item.status || "-",
    Reason: item.reason || "-",
  }));

  const worksheet = XLSX.utils.json_to_sheet(rows);

  const columnWidths = Object.keys(rows[0]).map((key) => ({
    wch:
      Math.max(
        key.length,
        ...rows.map((r) => String(r[key] || "").length)
      ) + 5,
  }));

  worksheet["!cols"] = columnWidths;

  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    "Detail Mutasi"
  );

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });

  saveAs(
    blob,
    `DETAIL_MUTASI_${selectedRow?.id_perintah_mutasi || "DATA"}.xlsx`
  );
};
const fetchScanDetail = async (id_perintah_mutasi) => {

  setLoadingScanModal(true);

  try {
    const res = await axios.get(
      "/api/warehouse/scan-instruksi-mutasi-md-detail",
      {
        params: { id_perintah_mutasi },
      }
    );

    const sorted = (res.data.items || []).sort((a, b) => {
      const aScanned = a.is_scanned ? 1 : 0;
      const bScanned = b.is_scanned ? 1 : 0;

      return bScanned - aScanned; // scanned di atas
    });

    setScanResult(sorted);

    setScanSummary({
      total: res.data.total || 0,
      scanned: res.data.scanned || 0,
      remaining: res.data.remaining || 0,
      status: res.data.status || "BELUM SESUAI",
    });

  } catch (err) {
    console.error(err);
  } finally {
    setLoadingScanModal(false);
  }
};

const fetchExportDetail = async (id_perintah_mutasi) => {
  try {
    const res = await axios.get(
      "/api/warehouse/get-instruksi-mutasi-detail-export",
      {
        params: { id_perintah_mutasi },
      }
    );

    return res.data.data || [];
  } catch (error) {
    console.error(error);
    return [];
  }
};

const [form, setForm] = useState({
  shipping_type: "TIKTOK", // 🔥 NEW
  handover_method: "PICKUP",
  pickup_slot_start: "",
  pickup_slot_end: "",
  shipping_provider: "",
  tracking_number: "",
});

const isValidSku = (sku) => {
  return /^\d{11}$/.test(sku); // hanya 11 digit angka
};


 const fetchData = async () => {
      try {
        const kode_toko = localStorage.getItem("kode_toko");

        const res = await axios.get("/api/warehouse/instruksi-mutasi-md", {
          params: { kode_toko },
        });

        setData(res.data.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

  // ===== FETCH =====
  useEffect(() => {
   
    fetchData();
  }, []);

  // ===== OUTSIDE CLICK =====
  useEffect(() => {
  const handleClickOutside = (e) => {
  // kalau klik di dalam menu / tombol → jangan close
  if (menuRef?.contains?.(e.target)) return;
  setOpenMenu(null);
};

  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, []);


const TableLoading = () => {
  return (
    <div className="p-4 space-y-3 animate-pulse">
      
      {[1,2,3,4,5,6,7,8,9,10].map((i) => (
        <div
          key={i}
          className="grid grid-cols-7 gap-4 items-center py-3"
        >

          {/* ID Surat Jalan */}
          <div className="h-5 bg-gray-200 rounded-lg col-span-1 w-[180px]" />

          {/* tanggal_instruksi */}
          <div className="h-4 bg-gray-200 rounded col-span-1 w-[120px]" />

          {/* User */}
          <div className="h-4 bg-gray-200 rounded col-span-1 w-[100px]" />

          {/* Status badge */}
          <div className="h-6 bg-gray-200 rounded-full col-span-1 w-[90px]" />

          {/* Jenis Inbound */}
          <div className="h-4 bg-gray-200 rounded col-span-1 w-[110px]" />

          {/* Total Qty */}
          <div className="h-4 bg-gray-200 rounded col-span-1 w-[70px]" />

          {/* Total HJP + action (digabung kanan) */}
          <div className="flex justify-end gap-2 col-span-1">

            <div className="h-4 w-[90px] bg-gray-200 rounded" />

            <div className="h-8 w-8 bg-gray-200 rounded-lg" />

          </div>

        </div>
      ))}

    </div>
  );
};

  // ===== FORMAT DATE =====
  const formatDate = (date) => {
  if (!date) return "-";

  return new Date(date).toLocaleString("id-ID", {
    timeZone: "Asia/Jakarta",
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
};


const getMinDateTime = () => {
  const now = new Date();

  // convert ke WIB (UTC+7)
  const wibOffset = 7 * 60;
  const localOffset = now.getTimezoneOffset();
  const wibTime = new Date(now.getTime() + (wibOffset + localOffset) * 60000);

  return wibTime.toISOString().slice(0, 16);
};

const getMaxDateTime = () => {
  const now = new Date();

  const wibOffset = 7 * 60;
  const localOffset = now.getTimezoneOffset();
  const wibTime = new Date(now.getTime() + (wibOffset + localOffset) * 60000);

  wibTime.setDate(wibTime.getDate() + 2); // 🔥 hanya 2 hari ke depan

  return wibTime.toISOString().slice(0, 16);
};

const normalizeUniqId = (value) => {
  if (!value) return "";

  const clean = value.trim();

  // ambil hash stable dari bagian awal (lebih aman daripada slice)
  return clean.substring(0, 11);
};


const getSLAStatus = (row) => {
  if (!row?.shipping_due_time) return "SAFE";

  const status = (row.status || "").toUpperCase();

  const SLA_STATUSES = [
    "AWAITING_COLLECTION",
    "BELUM POSTING",
  ];

  if (!SLA_STATUSES.includes(status)) return "SAFE";

  const now = Date.now();
  const due = new Date(row.shipping_due_time).getTime();

  if (isNaN(due)) return "SAFE"; // 🔥 guard kalau date rusak

  const diffMs = due - now;
  const diffHours = diffMs / (1000 * 60 * 60);

  if (diffMs < 0) return "OVERDUE";
  if (diffHours < 6) return "WARNING";

  return "SAFE";
};

const getRowColor = (item) => {
  const received = item.qty_received || 0;
  const total = item.qty || 0;

  if (received === 0) return "bg-white";
  if (received < total) return "bg-yellow-50 border-yellow-200";
  if (received >= total) return "bg-green-50 border-green-200";

  return "bg-white";
};

  // ===== STATUS TABS =====
  const statusTabs = useMemo(() => {
    const map = {};

    data.forEach((d) => {
      const s = d.status || "UNKNOWN";
      map[s] = (map[s] || 0) + 1;
    });

    return [
      { label: "All", value: "ALL", count: data.length },
      ...Object.keys(map).map((key) => ({
        label: key.replaceAll("_", " "),
        value: key,
        count: map[key],
      })),
    ];
  }, [data]);

  // ===== FILTER =====
  const filteredData = data.filter((item) => {
    const keyword = search.toLowerCase();

    const matchSearch =
      item.id_perintah_mutasi?.toLowerCase().includes(keyword)||
      item.tujuan?.toLowerCase().includes(keyword);

    const matchTab =
      activeTab === "ALL" || item.status === activeTab;

    return matchSearch && matchTab;
  });

  // ===== STATUS BADGE =====
  const getStatusColor = (status) => {
    const s = status?.toUpperCase();

    if (s === "SELESAI")
      return "bg-green-100 text-green-700";
    if (s === "PICKUP")
      return "bg-emerald-100 text-emerald-700";
    if (s === "IN_TRANSIT")
      return "bg-blue-100 text-blue-700";
    if (s === "PAID")
      return "bg-yellow-100 text-yellow-700";
    if (s === "AWAITING_COLLECTION")
      return "bg-purple-100 text-purple-700";
    if (s === "BELUM SELESAI" || s === "CANCEL")
      return "bg-red-100 text-red-700";

    return "bg-gray-100 text-gray-600";
  };

   const getStatusColorPenerimaan = (status_penerimaan) => {
    const s = status_penerimaan?.toUpperCase();

    if (s === "SUDAH DITERIMA")
      return "bg-green-100 text-green-700";
    if (s === "PICKUP")
      return "bg-emerald-100 text-emerald-700";
    if (s === "IN_TRANSIT")
      return "bg-blue-100 text-blue-700";
    if (s === "PAID")
      return "bg-yellow-100 text-yellow-700";
    if (s === "AWAITING_COLLECTION")
      return "bg-purple-100 text-purple-700";
    if (s === "BELUM DITERIMA" || s === "CANCEL")
      return "bg-red-100 text-red-700";

    return "bg-gray-100 text-gray-600";
  };

  

  const isDisabled =
  form.shipping_type === "SELF"
    ? !form.shipping_provider_id || !form.tracking_number
    : form.handover_method === "PICKUP" &&
      (!form.pickup_slot_start || !form.pickup_slot_end);


  // ===== ACTION =====
const handleAction = (type, row) => {
 if (type === "detail") {
   setSelectedRow(row); // 🔥 INI YANG KURANG
  setDetailModal(true);
  setLoadingDetail(true);
  const kode_toko = localStorage.getItem("kode_toko");

  axios
    .get("/api/warehouse/inbound-mutation-details", {
      params: { id_perintah_mutasi: row.id_perintah_mutasi,kode_tujuan: row.kode_tujuan,kode_toko:kode_toko },
    })
    .then((res) => {
      setOrderDetail(res.data.data);
    })
    .finally(() => setLoadingDetail(false));
}

if (type === "scan_produk") {
  setSelectedRow(row);
  setScanReceiveModal(true);

  fetchScanDetail(row.id_perintah_mutasi);

  setTimeout(() => {
    scanReceiveRef.current?.focus();
  }, 200);

  setOpenMenu(null);
}

  if (type === "invoice") {
    window.open(`/invoice/${row.id_perintah_mutasi}`, "_blank");
  }

  if (type === "shipping") {
    if (!row.doc_url) {
      alert("Shipping label belum tersedia");
      return;
    }

    window.open(row.doc_url, "_blank", "noopener,noreferrer");
  }

 if (type === "arrange_shipping") {
  setSelectedRow(row);
  setShippingModal(true);

  setForm({
    handover_method: "PICKUP",
    pickup_slot_start: "",
    pickup_slot_end: "",
  });
}

  setOpenMenu(null);
};


const generateKoliUniqId = () => {
  if (!selectedRow?.id_perintah_mutasi || !selectedKoli) {
    return "-";
  }

  return `${selectedRow.id_perintah_mutasi}-K${selectedKoli}`;
};

const groupedByToko = selectedMutasi.reduce((acc, item) => {
  const key = item.kode_toko_tujuan;

  if (!acc[key]) {
    acc[key] = [];
  }

  acc[key].push(item);

  return acc;
}, {});


const filteredScanResult = scanResult.filter((item) => {

  const keyword = searchScan.toLowerCase();

  return (
    item?.uniq_id?.toLowerCase().includes(keyword) ||
    item?.barcode?.toLowerCase().includes(keyword) ||
    item?.kode_extend?.toLowerCase().includes(keyword)
  );

});

 const canSaveKoli =
  selectedKoli && scanSummary.scanned > 0;

  const columns = [
    {
  name: "",
  width: "50px",
  cell: (row) => {
    const checked = selectedMutasi.some(
      (x) => x.id_perintah_mutasi === row.id_perintah_mutasi
    );

    return (
      <input
        type="checkbox"
        checked={checked}
        onChange={() => toggleSelectMutasi(row)}
        className="w-4 h-4 accent-emerald-600 cursor-pointer"
      />
    );
  },
},
  {
    name: "ID Perintah Mutasi",
    minWidth: "250px",
    grow: 2,
    cell: (row) => (
      <div className="py-2 whitespace-nowrap overflow-hidden text-ellipsis">
        <div className="font-medium text-gray-900 truncate">
          {row.id_perintah_mutasi}
        </div>
      </div>
      
    ),
  },

  {
    name: "Tanggal Perintah",
    minWidth: "150px",
    grow: 1,
    cell: (row) => {
      const date = row.tanggal_instruksi
        ? new Date(row.tanggal_instruksi)
        : null;

      return (
        <div className="text-sm text-gray-500 whitespace-nowrap">
          {date
            ? date.toLocaleDateString("id-ID", {
                year: "numeric",
                month: "short",
                day: "2-digit",
              })
            : "-"}
        </div>
      );
    },
  },

  {
    name: "Last Scan",
    minWidth: "150px",
    grow: 1,
    cell: (row) => {
      const date = row.tanggal_scan
        ? new Date(row.tanggal_scan)
        : null;

      return (
        <div className="text-sm text-gray-500 whitespace-nowrap">
          {date
            ? date.toLocaleDateString("id-ID", {
                year: "numeric",
                month: "short",
                day: "2-digit",
              })
            : "-"}
        </div>
      );
    },
  },

  {
    name: "Toko Tujuan",
    minWidth: "220px",
    grow: 3,
    cell: (row) => (
      <div className="py-2 whitespace-nowrap overflow-hidden text-ellipsis">
        <div className="font-medium text-gray-900 truncate">
          {row.tujuan}
        </div>
      </div>
    ),
  },

  {
    name: "Status",
    minWidth: "140px",
    grow: 1,
    cell: (row) => (
      <span
        className={`px-3 py-1 text-xs rounded-full font-medium whitespace-nowrap ${
          getStatusColor(row.status.toUpperCase())
        }`}
      >
        {row.status.toUpperCase()}
      </span>
    ),
  },

  {
    name: "Status Toko Tujuan",
    minWidth: "140px",
    grow: 1,
    cell: (row) => (
      <span
        className={`px-3 py-1 text-xs rounded-full font-medium whitespace-nowrap ${
          getStatusColorPenerimaan(row.status_penerimaan.toUpperCase())
        }`}
      >
        {row.status_penerimaan.toUpperCase()}
      </span>
    ),
  },

  {
    name: "Jenis Mutasi",
    minWidth: "180px",
    grow: 2,
    selector: (row) => row.keperluan || "Perintah MD",
  },

  {
    name: "Total Artikel",
    minWidth: "120px",
    grow: 1,
    selector: (row) =>
      new Intl.NumberFormat("id-ID", {
        minimumFractionDigits: 0,
      }).format(row.total_artikel || 0),
  },

  {
    name: "Total Qty (PCS)",
    minWidth: "140px",
    grow: 1,
    selector: (row) =>
      new Intl.NumberFormat("id-ID", {
        minimumFractionDigits: 0,
      }).format(row.total_qty || 0),
  },

  {
    name: "Total Diproses",
    minWidth: "140px",
    grow: 1,
    selector: (row) =>
      new Intl.NumberFormat("id-ID", {
        minimumFractionDigits: 0,
      }).format(row.qty_scan || 0),
  },
   {
    name: "Total Diterima",
    minWidth: "140px",
    grow: 1,
    selector: (row) =>
      new Intl.NumberFormat("id-ID", {
        minimumFractionDigits: 0,
      }).format(row.diterima || 0),
  },

  {
    name: "Total Sisa",
    minWidth: "120px",
    grow: 1,
    selector: (row) =>
      new Intl.NumberFormat("id-ID", {
        minimumFractionDigits: 0,
      }).format(row.sisa || 0),
  },

   {
      name: "",
      width: "60px",
      cell: (row) => (
        <div  ref={menuRef}>
         <button
  onClick={(e) => {
    
    const rect = e.currentTarget.getBoundingClientRect();

    const dropdownWidth = 160;
    const dropdownHeight = 120;

    let x = rect.right;
    let y = rect.bottom;

    if (x > window.innerWidth) {
      x = window.innerWidth - dropdownWidth - 10;
    }

    if (y + dropdownHeight > window.innerHeight) {
      y = rect.top - dropdownHeight;
    }

    setMenuPosition({ x, y });
    setOpenMenu(openMenu === row.id_perintah_mutasi ? null : row.id_perintah_mutasi);
  }}
  className="p-2 rounded-lg hover:bg-gray-100 transition"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-5 h-5 text-gray-600"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <circle cx="12" cy="5" r="2" />
    <circle cx="12" cy="12" r="2" />
    <circle cx="12" cy="19" r="2" />
  </svg>
</button>

       {openMenu === row.id_perintah_mutasi &&
  createPortal(
    <div
      className="fixed w-40 bg-white border rounded-lg shadow-lg z-[99999]"
      style={{
        top: menuPosition.y,
        left: menuPosition.x - 160,
      }}
      onMouseDown={(e) => e.stopPropagation()}
    >
    

       {/* 🔥 CONDITIONAL CETAK SURAT JALAN */}
      {Number(row.qty_scan) > 0 && (
        <button
          onClick={() => {
            window.open(
              `/api/warehouse/cetak-surat-jalan/${row.id_perintah_mutasi}`,
              "_blank"
            );

            setOpenMenu(null);
          }}
          className="w-full text-left px-4 py-2 text-sm hover:bg-gray-50 text-blue-600"
        >
          Cetak Surat Jalan
        </button>
      )}

      <button
  onClick={() => handleAction("scan_produk", row)}
  className="w-full text-left px-4 py-2 text-sm hover:bg-gray-50"
>
  Lihat Detail
</button>

     

     
    </div>,
    document.body
  )
}
        </div>
      ),
    },
];

const customStyles = {
  tableWrapper: {
    style: {
      overflow: "visible",
    },
  },
 table: {
  style: {
    border: "1px solid #e5e7eb",
    borderRadius: "12px",
    overflow: "hidden",
  },
},
  headRow: {
    style: {
      overflow: "visible",
    },
  },
rows: {
  style: (row) => {
    const sla = getSLAStatus(row);

    return {
      backgroundColor:
        sla === "OVERDUE"
          ? "#fee2e2"
          : sla === "WARNING"
          ? "#ffedd5"
          : "transparent",
      borderLeft:
        sla === "OVERDUE"
          ? "4px solid #dc2626"
          : sla === "WARNING"
          ? "4px solid #f97316"
          : "none",
          borderBottom: "1px solid #e5e7eb",
    };
  },
},
  cells: {
    style: {
      overflow: "visible",
    },
  },
  headCells: {
    style: {
      fontSize: "12px",
      fontWeight: "600",
      backgroundColor: "#f9fafb",
    },
  },
};

  return (
    <PageWrapper>
      {toast && (
  <div
    className={`fixed top-5 right-5 px-4 py-3 rounded-lg shadow-lg text-white z-[1000000]
      ${toast.type === "success" ? "bg-green-600" : "bg-red-600"}
    `}
  >
    {toast.message}
  </div>
)}
      <div className="space-y-5">

        {/* HEADER */}
        <div>
          <h1 className="text-xl font-semibold text-gray-800">
            Perintah Mutasi MD & Mandiri
          </h1>
          <p className="text-sm text-gray-500">
            Real-time order monitoring Perintah Mutasi MD & Mandiri
          </p>
        </div>

        {/* TABS */}
        {/* TABS */}
<div className="flex gap-3 flex-wrap bg-gray-50 p-2 rounded-2xl border">

 {statusTabs.map((tab) => {
  const isActive = activeTab === tab.value;
  const isSLA = tab.value === "BELUM POSTING";

  return (
    <button
      key={tab.value}
      onClick={() => setActiveTab(tab.value)}
      className={`flex items-center gap-2 px-5 py-3 rounded-xl border transition font-medium

        ${
          isActive
            ? isSLA
              ? "bg-red-600 text-white shadow-md"   // 🔥 aktif + SLA
              : "bg-gray-900 text-white shadow-md"
            : isSLA
              ? "bg-red-50 text-red-600 border-red-200 hover:bg-red-100" // 🔥 non aktif tapi highlight
              : "bg-white text-gray-700 hover:bg-gray-100"
        }
      `}
    >
      <span className="text-sm font-semibold">
        {tab.label}
      </span>

      <span
        className={`text-xs px-2 py-0.5 rounded-full
          ${
            isActive
              ? "bg-white/20 text-white"
              : isSLA
                ? "bg-red-100 text-red-600"
                : "bg-gray-100 text-gray-600"
          }
        `}
      >
        {tab.count}
      </span>

      {/* 🔥 optional: indikator SLA */}
      {isSLA && (
        <span className={`text-xs ${isActive ? "text-white" : "text-red-500"}`}>
          ●
        </span>
      )}
    </button>
  );
})}

</div>

        {/* TABLE */}
        <div className="bg-white border rounded-2xl shadow-sm p-4">

          {/* SEARCH */}
         <div className="flex justify-between mb-3 items-center">
  
  <input
    className="border rounded-xl px-3 py-2 text-sm w-72"
    placeholder="Search toko tujuan..."
    value={search}
    onChange={(e) => setSearch(e.target.value)}
  />

  <div className="flex items-center gap-2">

    <div className="text-xs text-gray-500">
      {filteredData.length} Surat Jalan
    </div>

    {/* 🔥 BUTTON LAPORAN */}
    <button
      onClick={() => window.open("/warehouse/mutasi-keluar-laporan", "_blank")}
      className="px-3 py-2 text-sm bg-black text-white rounded-xl hover:bg-black transition"
    >
      Laporan Mutasi Keluar
    </button>

  </div>
</div>

          {/* TABLE */}
          <DataTable
            columns={columns}
            data={filteredData}
                          progressPending={loading}
  progressComponent={<TableLoading />}
            pagination
            customStyles={customStyles}
            highlightOnHover
            persistTableHead
            
conditionalRowStyles={[
  {
    when: (row) => getSLAStatus(row) === "OVERDUE",
    style: {
      backgroundColor: "#fee2e2 !important",
      borderLeft: "4px solid #dc2626",
    },
  },
  {
    when: (row) => getSLAStatus(row) === "WARNING",
    style: {
      backgroundColor: "#ffedd5 !important",
      borderLeft: "4px solid #f97316",
    },
  },
]}
          />
        </div>
      </div>


{detailModal && (
  <div className="fixed inset-0 bg-black/60  backdrop-blur flex items-center justify-center z-[999999]">
     <div className="bg-white w-[600px] rounded-2xl p-6 shadow-xl">

      {/* HEADER */}
      <div className="flex justify-between items-center mb-4 sticky top-0 bg-white py-2">
       <div>
  <h2 className="text-lg font-bold">
    Surat Jalan Mutasi Masuk Detail
  </h2>

  {/* ORDER ID INFO */}
  <div className="text-xs text-gray-500 mt-1">
     ID Mutasi Toko:{" "}
    <span className="font-medium text-gray-700">
      {orderDetail?.[0]?.id_perintah_mutasi || "-"}
    </span>
  </div>
</div>

        <button
          onClick={() => setDetailModal(false)}
          className="text-gray-500 hover:text-black"
        >
          ✕
        </button>

        
      </div>

      {/* CONTENT */}
      {/* CONTENT */}
{loadingDetail ? (
 
  <div className="space-y-3">
    {[1,2,3,4,5].map((i) => (
      <div key={i} className="flex gap-3 animate-pulse">
        <div className="w-14 h-14 bg-gray-200 rounded-xl"></div>

        <div className="flex-1 space-y-2">
          <div className="h-3 w-40 bg-gray-200 rounded"></div>
          <div className="h-3 w-24 bg-gray-200 rounded"></div>
          <div className="h-3 w-32 bg-gray-200 rounded"></div>
        </div>
      </div>
    ))}
  </div>

) : (
  <>
    {/* TOP ACTION */}
   {/* TOP ACTION */}

   {isBelumPosting && (
  <div className="mb-3 p-3 rounded-xl bg-yellow-50 border border-yellow-200 text-xs text-gray-700 leading-relaxed flex gap-2">

    {/* ICON SIMPLE */}
    <div className="text-yellow-600 mt-0.5">
      ⚠
    </div>

    <div>
      <div className="font-medium text-gray-800 mb-1">
        Belum Posting
      </div>

      <div>
        Quantity per artikel & size harus sesuai hasil counting manual.
        Jika tidak menggunakan scan inbound uniq ID, pastikan semua item sudah dihitung ulang sebelum posting.
      </div>
    </div>

  </div>
)}
{isBelumPosting && (
  <div className="flex items-center justify-between mb-3">

    {/* CHECK ALL */}
    <label className="flex items-center gap-2 text-sm">
      <input
        type="checkbox"
        checked={
          orderDetail.length > 0 &&
          selectedItems.length === orderDetail.length
        }
        onChange={toggleAll}
      />

      Pilih Semua
    </label>

    {/* GROUP MODE */}
    <select
      value={groupMode}
      onChange={(e) => setGroupMode(e.target.value)}
      className="border rounded-lg px-3 py-1 text-sm"
    >
      <option value="uniq">
        View By Uniq ID
      </option>

      <option value="group">
        Group By SKU + Size
      </option>
    </select>
  </div>
)}

    <div className="space-y-3 max-h-[400px] overflow-auto">

      {/* ========================= */}
      {/* VIEW UNIQ */}
      {/* ========================= */}
      {groupMode === "uniq" &&
        orderDetail.map((item) => (
          <div
            key={item.uniq_id}
            className="border rounded-xl p-3 flex gap-3 items-start"
          >
            {/* CHECKBOX */}
            {/* CHECKBOX */}
{isBelumPosting && (
  <input
    type="checkbox"
    checked={selectedItems.includes(item.uniq_id)}
    onChange={() => toggleItem(item.uniq_id)}
    className="mt-1"
  />
)}

            <img
              src={item.photo}
              className="w-14 h-14 rounded-lg object-cover"
            />

            <div className="flex-1">
              <div className="font-medium text-sm">
                {item.uniq_id}
              </div>

              <div className="flex items-center justify-between mt-1 gap-2">
  <div
    className={`text-xs font-medium ${
      isValidSku(item.kode_extend)
        ? "text-gray-500"
        : "text-red-600"
    }`}
  >
    SKU: {item.kode_extend || "-"} -{" "}
    {item.ukuran || "-"}
  </div>

  <div className="text-xs font-bold bg-gray-100 px-3 py-1 rounded-lg whitespace-nowrap">
    Qty: {item.qty}
  </div>
</div>

              <div className="text-sm font-semibold mt-1">
                Rp {item.hjp}
              </div>
            </div>
          </div>
        ))}

      {/* ========================= */}
      {/* GROUP VIEW */}
      {/* ========================= */}
      {groupMode === "group" &&
        groupedData.map((group, idx) => (
          <div
            key={idx}
            className="border rounded-xl p-4"
          >
            <div className="flex justify-between items-center">
              <div>
                <div className="font-semibold text-sm">
                  {group.kode_extend}
                </div>

                <div className="text-xs text-gray-500">
                  Size: {group.ukuran}
                </div>
              </div>

              <div className="text-sm font-bold bg-gray-100 px-3 py-1 rounded-lg">
                Qty: {group.qty}
              </div>
            </div>

            {/* LIST ITEM */}
           <div className="mt-3 space-y-2">
  {group.items.map((item) => (
    <label
      key={item.uniq_id}
      className="flex items-center gap-2 text-sm"
    >

      {isBelumPosting && (
        <input
          type="checkbox"
          checked={selectedItems.includes(
            item.uniq_id
          )}
          onChange={() =>
            toggleItem(item.uniq_id)
          }
        />
      )}

      {item.uniq_id}
    </label>
  ))}
</div>
          </div>
        ))}
    </div>
  </>
)}

     {/* FOOTER ACTION */}
<div className="mt-5 flex justify-between gap-2 border-t pt-4">

  <button
    onClick={exportDetailToExcel}
    className="px-4 py-2 text-sm bg-emerald-600 text-white rounded-lg hover:bg-emerald-700"
  >
    Export Excel
  </button>

  <div className="flex gap-2">
    <button
      onClick={() => setDetailModal(false)}
      className="px-4 py-2 text-sm bg-gray-200 rounded-lg hover:bg-gray-300"
    >
      Tutup
    </button>
  </div>

</div>
      

    </div>
  </div>
)}

{uniqModal && scanItem && (
  <div className="fixed inset-0 bg-black/60 backdrop-blur flex items-center justify-center z-[999999]">
    
    <div className="bg-white w-[420px] rounded-2xl p-5 shadow-xl space-y-4">

      {/* HEADER */}
      <div className="flex justify-between items-center">
        <div>
          <div className="font-bold">Scan / Set Unique ID</div>
          <div className="text-xs text-gray-500">
            {scanItem.product_name}
          </div>
        </div>

        <button
          onClick={() => setUniqModal(false)}
          className="text-gray-500 hover:text-black"
        >
          ✕
        </button>
      </div>

      {/* QR IMAGE PREVIEW */}
      <div className="flex justify-center">
        <img
          src={`https://api.qrserver.com/v1/create-qr-code/?size=160x160&data=${scanItem.unique_id || scanItem.line_item_id}`}
          className="w-40 h-40 border rounded-xl"
        />
      </div>

      {/* INFO */}
      <div className="text-center text-xs text-gray-500">
        Scan QR tag pada barang atau masukkan manual ID
      </div>

      {/* INPUT MANUAL */}
      <input
        value={uniqInput}
        onChange={(e) => setUniqInput(e.target.value)}
        placeholder="Masukkan / Scan Unique ID"
        className="w-full border rounded-xl px-3 py-2 text-sm"
      />

      {/* ACTION */}
      <div className="flex gap-2 justify-end">
        <button
          onClick={() => setUniqModal(false)}
          className="px-4 py-2 text-sm border rounded-xl"
        >
          Cancel
        </button>

        <button
          onClick={() => {
            axios.post("/api/tiktokshop/set-unique-id", {
              line_item_id: scanItem.line_item_id,
              unique_id: uniqInput,
            })
            .then(() => {
              showToast("Unique ID tersimpan", "success");

              setOrderDetail((prev) =>
                prev.map((d) =>
                  d.line_item_id === scanItem.line_item_id
                    ? { ...d, unique_id: uniqInput }
                    : d
                )
              );

              setUniqModal(false);
            })
            .catch(() => showToast("Gagal simpan ID", "error"));
          }}
          className="px-4 py-2 text-sm bg-purple-600 text-white rounded-xl"
        >
          Simpan
        </button>
      </div>

    </div>
  </div>
)}

{skuModal && skuItem && (
  <div className="fixed inset-0 bg-black/60 backdrop-blur flex items-center justify-center z-[999999]">

    <div className="bg-white w-[450px] rounded-2xl p-5 space-y-4">

      {/* HEADER */}
      <div className="flex justify-between items-center">
        <div>
          <div className="font-bold">Barcode SKU</div>
          <div className="text-xs text-gray-500">
            {skuItem.product_name}
          </div>
        </div>

        <button
          onClick={() => setSkuModal(false)}
          className="text-gray-500 hover:text-black"
        >
          ✕
        </button>
      </div>

      {/* 🧾 BARCODE IMAGE */}
      <div className="flex flex-col items-center gap-2">
        <img
  src={`https://bwipjs-api.metafloor.com/?bcid=code128&text=${encodeURIComponent(
    skuItem.seller_sku || ""
  )}&scale=2&height=10&includetext`}
  alt="barcode"
  className="w-[220px] h-[80px] object-contain bg-white p-2 border rounded-lg"
/>

        <div className="text-xs text-gray-500">
          SKU: <span className="font-medium">{skuItem.seller_sku}</span>
        </div>
      </div>

      {/* INPUT MANUAL */}
      <input
        value={skuInput}
        onChange={(e) => setSkuInput(e.target.value)}
        placeholder="Edit SKU manual"
        className="w-full border rounded-xl px-3 py-2 text-sm"
      />

      {/* ACTION */}
      <div className="flex justify-end gap-2">
        <button
          onClick={() => setSkuModal(false)}
          className="px-4 py-2 text-sm border rounded-xl"
        >
          Cancel
        </button>

        <button
          onClick={() => {
            axios.post("/api/tiktokshop/update-sku", {
              line_item_id: skuItem.line_item_id,
              seller_sku: skuInput,
            })
            .then(() => {
              showToast("SKU berhasil diupdate", "success");

              setOrderDetail((prev) =>
                prev.map((d) =>
                  d.line_item_id === skuItem.line_item_id
                    ? { ...d, seller_sku: skuInput }
                    : d
                )
              );

              setSkuModal(false);
            })
            .catch(() => showToast("Gagal update SKU", "error"));
          }}
          className="px-4 py-2 text-sm bg-yellow-500 text-white rounded-xl"
        >
          Simpan SKU
        </button>
      </div>

    </div>
  </div>
)}

{scanReceiveModal && (
  <div className="fixed inset-0 bg-black/60 backdrop-blur flex items-center justify-center z-[999999] p-4">

    {/* MODAL */}
    <div className="bg-white w-[1400px] max-w-[98vw] h-[92vh] rounded-2xl shadow-2xl overflow-hidden flex">

      {/* ========================= */}
      {/* LEFT PANEL */}
      {/* ========================= */}
      <div className="w-[430px] border-r bg-white flex flex-col">

        {/* HEADER */}
        <div className="p-6 border-b">

          <div className="flex items-start justify-between gap-4">

           <div className="flex items-start justify-between w-full gap-4">

  <div>
    <div className="font-bold text-2xl text-gray-800">
      Scan Produk Mutasi
    </div>

    <div className="text-sm text-gray-500 mt-1">
      {selectedRow?.id_perintah_mutasi}
    </div>
  </div>

  <button
  onClick={exportDetailToExcel}
  className="
    w-10 h-10
    flex items-center justify-center
    bg-emerald-600
    hover:bg-emerald-700
    text-white
    rounded-xl
    shadow-sm
    transition
  "
  title="Export Excel"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-5 h-5"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 16V4m0 12-4-4m4 4 4-4"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 20h16"
    />
  </svg>
</button>

</div>

            <button
              onClick={() => {
                setScanReceiveModal(false);
                setSelectedKoli("");
              }}
              className="text-gray-400 hover:text-black text-2xl"
            >
              ✕
            </button>

          </div>

          {/* WARNING */}
         

          {/* INFO */}
          <div className="mt-4">

            <div className="bg-gray-50 border rounded-xl px-4 py-3">

              <div className="text-[11px] uppercase tracking-wide text-gray-500">
                Toko Tujuan
              </div>

              <div className="text-sm font-semibold text-gray-800 mt-1">
                {selectedRow?.tujuan || "-"}
              </div>

            </div>

          </div>

        </div>

        {/* BODY */}
        <div className="flex-1 overflow-y-auto p-6 space-y-5">

          {/* SUMMARY */}
          <div className="grid grid-cols-2 gap-3">

            <div className="border rounded-xl p-4 bg-white">
              <div className="text-xs text-gray-500">
                Total Item
              </div>

              <div className="text-2xl font-bold text-gray-800 mt-1">
                {scanSummary.total}
              </div>
            </div>

            <div className="border rounded-xl p-4 bg-green-50 border-green-200">
              <div className="text-xs text-green-600">
                Sudah Scan
              </div>

              <div className="text-2xl font-bold text-green-700 mt-1">
                {scanSummary.scanned}
              </div>
            </div>

            <div className="border rounded-xl p-4 bg-yellow-50 border-yellow-200">
              <div className="text-xs text-yellow-700">
                Belum Scan
              </div>

              <div className="text-2xl font-bold text-yellow-800 mt-1">
                {scanSummary.remaining}
              </div>
            </div>

            <div
              className={`border rounded-xl p-4 ${
                scanSummary.remaining === 0
                  ? "bg-emerald-50 border-emerald-200"
                  : "bg-red-50 border-red-200"
              }`}
            >

              <div className="text-xs text-gray-600">
                Status
              </div>

              <div
                className={`text-lg font-bold mt-1 ${
                  scanSummary.remaining === 0
                    ? "text-emerald-700"
                    : "text-red-700"
                }`}
              >
                {scanSummary.remaining === 0
                  ? "SESUAI"
                  : "BELUM SESUAI"}
              </div>

            </div>

          </div>

          {/* PILIH KOLI */}
          <div>

            <div className="text-sm font-medium text-gray-700 mb-2">
              Pilih Nomor Koli
            </div>

            <select
  value={selectedKoli}
  disabled={isKoliLocked}
  onChange={(e) => setSelectedKoli(e.target.value)}
  className={`w-full border-2 rounded-xl px-4 py-3 outline-none transition
    ${
      isKoliLocked
        ? "bg-gray-100 border-gray-200 text-gray-400 cursor-not-allowed"
        : "border-gray-200 focus:border-emerald-500"
    }
  `}
>
  <option value="">-- Pilih Nomor Koli --</option>

  {[1, 2, 3, 4, 5].map((koli) => (
    <option key={koli} value={String(koli)}>
      Koli {koli}
    </option>
  ))}
</select>

            {/* UNIQUE KOLI ID */}


          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">

  <div className="text-xs text-blue-600 uppercase tracking-wide">
   ID Mutasi by UID Koli
  </div>

  <div className="text-lg font-bold text-blue-800 mt-1">
    {generateKoliUniqId()}
  </div>

</div>

          {/* PROGRESS */}
          <div>

            <div className="flex justify-between text-sm mb-2">

              <span className="font-medium text-gray-700">
                Progress Scan
              </span>

              <span className="font-semibold text-gray-700">
                {scanSummary.scanned}/{scanSummary.total}
              </span>

            </div>

            <div className="h-4 bg-gray-100 rounded-full overflow-hidden">

              <div
                className="h-full bg-emerald-500 transition-all duration-300"
                style={{
                  width: `${
                    scanSummary.total > 0
                      ? (scanSummary.scanned /
                          scanSummary.total) *
                        100
                      : 0
                  }%`,
                }}
              />

            </div>

          </div>

          {/* INPUT */}
          <div>

            <div className="flex items-center justify-between mb-2">

              <div className="text-sm font-medium text-gray-700">
                Scan Unique ID
              </div>

              {selectedKoli && (
                <div className="text-xs bg-emerald-100 text-emerald-700 px-3 py-1 rounded-lg font-medium">
                  Koli Aktif: {selectedKoli}
                </div>
              )}

            </div>

            <input
              ref={scanReceiveRef}
              value={scanReceiveInput}
              disabled={!selectedKoli}

              onChange={(e) =>
                setScanReceiveInput(e.target.value)
              }

              onKeyDown={(e) => {

                if (e.key === "Enter") {

                  if (!selectedKoli) {

                    showToast(
                      "Pilih nomor koli terlebih dahulu",
                      "warning"
                    );

                    return;
                  }

                  const kode_toko =
                    localStorage.getItem("kode_toko");

                     const id_sunfish =
                    localStorage.getItem("id_sunfish");

                  const totalQty = Number(
                    selectedRow?.total_qty || 0
                  );

                  const receivedQty = Number(
                    selectedRow?.qty_received || 0
                  );

                  if (receivedQty >= totalQty) {

                    showToast(
                      "Qty sudah terpenuhi, tidak bisa scan lagii",
                      "error"
                    );

                    return;
                  }

               const rawScan = scanReceiveInput.trim();

axios
  .post(
    "/api/warehouse/scan-mutasi-md",
    {
      id_perintah_mutasi:
        selectedRow?.id_perintah_mutasi,

      uniq_id: rawScan,

      kode_toko,
      id_sunfish,

      nomor_koli: selectedKoli,

      uniq_koli_id: generateKoliUniqId(),
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  )

  .then((res) => {

  setIsKoliLocked(true); // 🔥 LOCK KOLI SAAT SCAN PERTAMA

  console.log("SCAN SUCCESS =>", res.data);

  showToast(
    `Barang ${scanReceiveInput} diterima`,
    "success"
  );

  setScanReceiveInput("");

  fetchData();

  fetchScanDetail(
    selectedRow.id_perintah_mutasi
  );

})

  .catch((err) => {

    console.log("AXIOS ERROR =>", err);

    console.log(
      "AXIOS RESPONSE =>",
      err?.response
    );

    const message =
      err?.response?.data?.message;

    if (
      message ===
      "Qty sudah terpenuhi"
    ) {

      showToast(
        "Qty sudah terpenuhi, tidak bisa scan",
        "error"
      );

      return;
    }

    if (
      message ===
      "Barang sudah diterima"
    ) {

      showToast(
        "Barang ini sudah discan sebelumnya",
        "warning"
      );

      return;
    }

    if (
      message ===
      "Barang tidak ditemukan"
    ) {

      showToast(
        "Barang tidak ditemukan",
        "error"
      );

      return;
    }

    if (
      message ===
      "Barcode harus 11 atau 17 digit"
    ) {

      showToast(
        "Barcode harus 11 atau 17 digit",
        "warning"
      );

      return;
    }

    if (
      message ===
      "Data tidak lengkap"
    ) {

      showToast(
        "Data request tidak lengkap",
        "error"
      );

      return;
    }

    showToast(
      message || "Terjadi kesalahan",
      "error"
    );

  });

                }

              }}

              placeholder={
                selectedKoli
                  ? "Scan uniq ID..."
                  : "Pilih nomor koli terlebih dahulu"
              }

              className={`w-full border-2 rounded-xl px-5 py-4 text-lg font-medium outline-none transition ${
                !selectedKoli
                  ? "bg-gray-100 border-gray-200 cursor-not-allowed text-gray-400"
                  : "border-gray-200 focus:border-emerald-500 focus:ring-0"
              }`}
            />

          </div>

        </div>

        {/* FOOTER */}
        {/* FOOTER */}
<div className="p-6 border-t">

  <div className="flex gap-3">

    {/* SIMPAN KOLI */}
   <button
  disabled={!canSaveKoli}
  onClick={() => {
    if (!selectedKoli) {
      showToast(
        "Pilih nomor koli terlebih dahulu",
        "warning"
      );
      return;
    }

    if (scanSummary.scanned === 0) {
      showToast(
        "Belum ada barang yang di-scan",
        "warning"
      );
      return;
    }

    axios.post("/api/warehouse/simpan-koli-mutasi", {
      id_perintah_mutasi: selectedRow?.id_perintah_mutasi,
      nomor_koli: selectedKoli,
      uniq_koli_id: generateKoliUniqId(),
    })
    .then(() => {
      showToast(
        `Koli ${selectedKoli} berhasil disimpan`,
        "success"
      );

      setIsKoliLocked(false);
      setSelectedKoli("");
      setScanReceiveInput("");
    })
    .catch((err) => {
      showToast(
        err?.response?.data?.message ||
          "Gagal menyimpan koli",
        "error"
      );
    });
  }}
  className={`flex-1 font-semibold px-5 py-3 rounded-xl transition
    ${
      canSaveKoli
        ? "bg-emerald-600 hover:bg-emerald-700 text-white"
        : "bg-gray-300 text-gray-500 cursor-not-allowed"
    }
  `}
>
  Simpan Koli
</button>

    {/* TUTUP */}
    <button
      onClick={() => {
  setScanReceiveModal(false);
  setSelectedKoli("");
  setIsKoliLocked(false); // 🔥 RESET LOCK
}}
      className="flex-1 border border-gray-300 hover:bg-gray-100 text-gray-700 font-medium px-5 py-3 rounded-xl transition"
    >
      Tutup
    </button>

  </div>

</div>

      </div>

      {/* ========================= */}
      {/* RIGHT PANEL */}
      {/* ========================= */}
      <div className="flex-1 flex flex-col bg-gray-50">

        {/* HEADER */}
        <div className="px-6 py-5 border-b bg-white">

          <div className="text-xl font-bold text-gray-800">
            Daftar Hasil Scan
          </div>

          <div className="text-sm text-gray-500 mt-1">
            Monitoring item yang sudah diproses
          </div>

        </div>

{/* SEARCH */}
<div className="px-6 py-4 bg-white border-b">

  <div className="relative">

    <input
      type="text"
      value={searchScan}
      onChange={(e) => setSearchScan(e.target.value)}
      placeholder="Cari uniq id / barcode / artikel..."
      className="w-full border border-gray-200 focus:border-emerald-500 focus:ring-0 rounded-xl pl-11 pr-4 py-3 outline-none text-sm"
    />

 <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-4 h-4"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={1.8}
  >
    <circle cx="11" cy="11" r="7" />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m20 20-3.5-3.5"
    />
  </svg>
</div>

  </div>

</div>
        {/* TABLE HEADER */}
       <div className="grid grid-cols-6 bg-gray-100 px-6 py-3 border-b text-xs font-semibold text-gray-500 uppercase tracking-wide">
  <div>Pict</div>
  <div>Unique ID</div>
  <div>Artikel</div>
  <div>Koli</div>
  <div>Status</div>
  <div className="text-center">Action</div>

</div>

        {/* TABLE BODY */}
       <div className="flex-1 overflow-y-auto relative">

  {loadingScanModal && (
   <TableLoading />
  )}

          {scanResult.length === 0 && (

            <div className="h-full flex items-center justify-center text-sm text-gray-400">
              Belum ada item discan
            </div>

          )}

          {filteredScanResult.map((item, idx) => (

            <div
              key={idx}
              className={`grid grid-cols-6 items-center px-6 py-4 border-b bg-white hover:bg-gray-50 transition ${getRowColor(item)}`}      >

              {/* UNIQUE ID */}
              {/* IMAGE */}
{/* IMAGE */}
<div className="flex justify-start">

  {item.photo ? (

    <img
      src={item.photo}
      alt={item.kode_extend}
      className="w-12 h-12 rounded-lg object-cover border cursor-pointer hover:scale-105 transition"
      onClick={() => {
        setPreviewImage(item.photo);
        setZoom(1);
      }}
      onError={(e) => {
        e.target.src = "https://placehold.co/400";
      }}
    />

  ) : (

    <div className="w-12 h-12 rounded-lg bg-gray-100 flex items-center justify-center text-[10px] text-gray-400">
      No Img
    </div>

  )}

</div>
              
              <div>

                <div className="font-semibold text-sm text-gray-800">
                  {item.uniq_id}
                </div>

                <div className="text-xs text-gray-500 mt-1">
                  {item.barcode}
                </div>

              </div>

              {/* SKU */}
              <div>

                <div className="text-sm font-medium text-gray-700">
                  {item.kode_extend}
                </div>

                <div className="text-xs text-gray-500 mt-1 flex gap-2">

                  <span>Size: {item.ukuran}</span>

                  <span>|</span>

                  <span>
                    {item.qty_received || 0}/{item.total_qty}
                  </span>

                </div>

              </div>

              {/* KOLI */}
              <div>

                <span className="text-xs bg-blue-100 text-blue-700 px-3 py-1 rounded-lg font-medium">
                  Koli {item.nomor_koli || "-"}
                </span>

              </div>

              {/* STATUS */}
            {/* STATUS */}
<div className="flex justify-start">

  {item.is_scanned ? (

    item.status === "BELUM SELESAI" ? (

      <span className="text-xs bg-yellow-100 text-yellow-700 px-3 py-1 rounded-lg font-medium">
        BELUM SELESAI
      </span>

    ) : (

      <span className="text-xs bg-green-100 text-green-700 px-3 py-1 rounded-lg font-medium">
        SELESAI
      </span>

    )

  ) : (

    <span className="text-xs bg-gray-100 text-gray-500 px-3 py-1 rounded-lg font-medium">
      Pending
    </span>

  )}

</div>
              {/* ACTION */}
{/* ACTION */}
<div className="flex justify-center">

  {/* ACTION */}
<div className="flex justify-center">

  {item.status !== "SELESAI" && (
    <button
      onClick={() => {
        setSelectedReasonItem(item);
        setReasonText(item.reason || "");
        setReasonModal(true);
      }}
      className="text-xs bg-amber-100 hover:bg-amber-200 text-amber-700 px-3 py-1 rounded-lg font-medium transition"
    >
      Reason
    </button>
  )}

</div>

</div>

            </div>

          ))}

        </div>

      </div>

    </div>

  </div>
)}

{previewImage && (
  <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-[999999]">

    {/* CLOSE */}
    <button
      onClick={() => setPreviewImage(null)}
      className="absolute top-5 right-5 text-white text-2xl"
    >
      ✕
    </button>

    {/* ZOOM CONTROLS */}
    <div className="absolute bottom-6 flex gap-3">

      <button
        onClick={() => setZoom((z) => Math.max(0.5, z - 0.2))}
        className="bg-white px-3 py-1 rounded"
      >
        -
      </button>

      <button
        onClick={() => setZoom(1)}
        className="bg-white px-3 py-1 rounded"
      >
        Reset
      </button>

      <button
        onClick={() => setZoom((z) => Math.min(3, z + 0.2))}
        className="bg-white px-3 py-1 rounded"
      >
        +
      </button>

    </div>

    {/* IMAGE */}
    <img
      src={previewImage}
      style={{
        transform: `scale(${zoom})`,
        transition: "0.2s",
        maxHeight: "85vh",
        maxWidth: "85vw",
      }}
      className="rounded-lg"
    />

  </div>
)}

{selectedMutasi.length > 0 && (
  <div className="fixed bottom-5 right-5 bg-white shadow-xl border rounded-2xl p-4 w-[320px] z-50">

    {/* HEADER */}
    <div className="flex items-center justify-between mb-3">
      <div className="text-sm font-semibold text-gray-800">
        {selectedMutasi.length} Mutasi dipilih
      </div>

      <button
        onClick={() => setSelectedMutasi([])}
        className="text-gray-400 hover:text-gray-600 text-sm"
      >
        ✕
      </button>
    </div>

    {/* INFO */}
    <div className="text-xs text-gray-500 mb-3">
      Mutasi akan ditolak berdasarkan grouping toko tujuan
    </div>

    {/* BUTTON */}
    <button
      onClick={() => setRejectModalOpen(true)}
      className="w-full bg-red-600 hover:bg-red-700 text-white py-2 rounded-xl text-sm font-semibold transition"
    >
      Tolak Mutasi
    </button>

  </div>
)}

{rejectModalOpen && (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999]">

    <div className="bg-white w-[420px] rounded-2xl shadow-xl p-5">

      {/* TITLE */}
      <div className="text-lg font-bold text-gray-800 mb-2">
        Tolak Mutasi
      </div>

      <div className="text-sm text-gray-500 mb-4">
        Anda akan menolak <b>{selectedMutasi.length}</b> mutasi
      </div>

      {/* GROUP PREVIEW */}
      <div className="bg-gray-50 border rounded-xl p-3 mb-4 max-h-[120px] overflow-y-auto">
        {Object.entries(groupedByToko).map(([toko, items]) => (
          <div key={toko} className="text-xs text-gray-700 mb-1">
            <b>{toko}</b> ({items.length})
          </div>
        ))}
      </div>

      {/* REASON INPUT */}
      <textarea
        value={rejectReason}
        onChange={(e) => setRejectReason(e.target.value)}
        placeholder="Masukkan alasan penolakan..."
        className="w-full border rounded-xl p-3 text-sm outline-none focus:ring-2 focus:ring-red-200"
        rows={3}
      />

      {/* ACTION BUTTON */}
      <div className="flex gap-2 mt-4">

        <button
          onClick={() => {
            setRejectModalOpen(false);
            setRejectReason("");
          }}
          className="flex-1 border py-2 rounded-xl text-sm hover:bg-gray-100"
        >
          Batal
        </button>

       <button
  onClick={async () => {
    if (!rejectReason.trim()) return;

    try {
      await axios.post("/api/warehouse/reject-mutasi-batch", {
        items: selectedMutasi,
        alasan: rejectReason,
      });

      showToast("Mutasi berhasil ditolak", "success");

      setRejectModalOpen(false);
      setRejectReason("");
      setSelectedMutasi([]);

      // optional refresh data
      fetchData?.();

    } catch (err) {
      showToast(
        err?.response?.data?.message || "Gagal menolak mutasi",
        "error"
      );
    }
  }}
  className="flex-1 bg-red-600 hover:bg-red-700 text-white py-2 rounded-xl text-sm font-semibold"
>
  Konfirmasi Tolak
</button>
      </div>

    </div>

  </div>
)}

{reasonModal && selectedReasonItem && (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[999999]">

    <div className="bg-white w-[450px] rounded-2xl shadow-xl p-6">

      {/* HEADER */}
      <div className="flex items-center justify-between mb-4">

        <div>
          <div className="text-lg font-bold text-gray-800">
            Reason Item
          </div>

          <div className="text-xs text-gray-500 mt-1">
            {selectedReasonItem.uniq_id}
          </div>
        </div>

        <button
          onClick={() => {
            setReasonModal(false);
            setSelectedReasonItem(null);
            setReasonText("");
            setReasonQty(1);
          }}
          className="text-gray-400 hover:text-black"
        >
          ✕
        </button>

      </div>

      {/* ITEM INFO */}
      <div className="border rounded-xl p-3 bg-gray-50 mb-4">

        <div className="text-sm font-semibold text-gray-700">
          {selectedReasonItem.kode_extend}
        </div>

        <div className="text-xs text-gray-500 mt-1">
          Barcode: {selectedReasonItem.barcode}
        </div>

      </div>

      {/* TEXTAREA */}
      {/* PILIHAN REASON */}
<div>

  <div className="text-sm font-medium text-gray-700 mb-2">
    Pilih Reason
  </div>

  <select
  value={reason}
  onChange={(e) => setReason(e.target.value)}
  className="w-full border rounded-xl px-3 py-2 text-sm"
>
  <option value="">Pilih Reason</option>
  <option value="BARANG_HILANG">
    Barang hilang
  </option>
  <option value="REJECT">
   Reject
  </option>

  <option value="KEEPING_ORDER">
    Keeping Order
  </option>

   <option value="TERJUAL">
    Terjual
  </option>
</select>

</div>

<div className="mb-4">
  <div className="text-sm font-medium text-gray-700 mb-2">
    Qty Reason
  </div>

  <input
    type="number"
    min="1"
    value={reasonQty}
    onChange={(e) => setReasonQty(e.target.value)}
    className="w-full border rounded-xl px-3 py-2 text-sm"
    placeholder="Masukkan qty"
  />
</div>

      {/* ACTION */}
      <div className="flex gap-2 justify-end mt-5">

        <button
          onClick={() => {
            setReasonModal(false);
            setSelectedReasonItem(null);
            setReasonText("");
          }}
          className="px-4 py-2 border rounded-xl text-sm hover:bg-gray-100"
        >
          Batal
        </button>

       <button
  onClick={() => {

    if (!reason) {
      showToast("Reason wajib dipilih", "warning");
      return;
    }

    axios.post("/api/warehouse/reason-mutasi-item", {

      barcode: selectedReasonItem.barcode,
      id_perintah_mutasi:
        selectedRow?.id_perintah_mutasi,
         qty: reasonQty,

      reason,

    })

    .then(() => {

      showToast(
        "Reason berhasil disimpan",
        "success"
      );

      fetchScanDetail(
        selectedRow.id_perintah_mutasi
      );

      setReasonModal(false);

      setSelectedReasonItem(null);

      setReason("");

    })

    .catch((err) => {

      showToast(
        err?.response?.data?.message ||
        "Gagal simpan reason",
        "error"
      );

    });

  }}
  className="
    px-4 py-2
    bg-amber-500
    hover:bg-amber-600
    text-white
    rounded-xl
    text-sm
    font-medium
  "
>
  Simpan Reason
</button>
      </div>

    </div>

  </div>
)}

    </PageWrapper>
  );
}